<script setup lang="ts">
import { onBeforeMount } from "vue";
import { useUserStore } from "@/modules/user-module";
import { useRouter } from "vue-router";

const userStore = useUserStore();
const router = useRouter();

onBeforeMount(() => {
  userStore
    .urlRedirect({ link: window.location.pathname })
    .then((link) => {
      window.location.href = link;
    })
    .catch(() => {
      router.push({ name: "HomeView" });
    });
});
</script>

<template>
  <main></main>
</template>
